import { createSlice } from '@reduxjs/toolkit'
import SuppliersServices from '../../services/suppliersServices';
import UsersServices from '../../services/usersServices';

const initialState = {
  users: []
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    usersLoaded(state, action) {
      state.users = action.payload;
    }
  },
})

export const { usersLoaded } = usersSlice.actions;

export default usersSlice.reducer;

export const fetchusersList = () => async (dispatch) => { 
  try {
     let filters={enabled: true};

    const respData = await UsersServices.getUsers(filters);
    if (respData.success) {
      const usersList = respData.responseObject.value.usersList;    

      if(usersList){
        const objectsArray = usersList.map((item) => ({ value: item.id, label: (item.name + " " + item.surname) }));
        dispatch(usersLoaded(objectsArray));
      }
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

